import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { NativeAppService, TrackingService } from '@frontend/vanilla/core';
import { LhHeaderBarComponent } from '@frontend/vanilla/features/header-bar';

@Component({
    selector: 'pt-phone-option',
    templateUrl: 'phone-option.component.html',
    imports: [LhHeaderBarComponent],
})
export class PhoneOptionComponent implements OnInit {
    initData: any;

    @Input() phoneData: any;
    @Output() disablePhoneScreen: EventEmitter<boolean> = new EventEmitter();
    constructor(
        @Optional() private dialogRef: MatDialogRef<PhoneOptionComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
        private tracking: TrackingService,
        private nativeApplicationService: NativeAppService,
    ) {}

    ngOnInit() {
        this.capturePageLoadTracking('Help_Contact_ContactOptions_CallUs');
        this.initData = this.phoneData;
    }

    gotoHome(dialog?: string) {
        this.captureEventTracking('Help_Contact_ContactOptions_CallUs_Close');
        // for v6 close action
        if (this.dialogRef) {
            this.dialogRef.close();
        }
        // for v4 close action
        if (dialog !== 'POPUP') {
            this.disablePhoneScreen.emit(false);
        }
    }

    callTo(phoneNumber: any) {
        this.captureEventTracking('Help_Contact_ContactOptions_CallUs_PhoneNumber_Clicked');
        if (this.nativeApplicationService.isNativeWrapper || this.nativeApplicationService.isDownloadClient) {
            window.open('tel:' + phoneNumber);
        } else {
            window.location.href = 'tel:' + phoneNumber;
        }
    }
    private captureEventTracking(eventName: string) {
        this.tracking.triggerEvent('Event.Functionality.HelpContact', { 'page.referringAction': eventName });
    }

    private capturePageLoadTracking(eventName: string) {
        this.tracking.triggerEvent('pageView', { 'page.name': eventName });
    }
}
